import { Stack, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LEGAL_DOCUMENTS } from '../legalConfig';

type PrivacyLinksBlockProps = {
  compact?: boolean;
};

export default function PrivacyLinksBlock({ compact = false }: PrivacyLinksBlockProps) {
  return (
    <Stack spacing={compact ? 0.5 : 1}>
      <Typography variant="body2" color="text.secondary">
        Consultez les documents légaux avant validation.
      </Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <MuiLink component={RouterLink} to={LEGAL_DOCUMENTS.terms.path} underline="hover">
          Conditions Générales de Vente
        </MuiLink>
        <MuiLink component={RouterLink} to={LEGAL_DOCUMENTS.privacy.path} underline="hover">
          Politique de confidentialité
        </MuiLink>
        <MuiLink component={RouterLink} to={LEGAL_DOCUMENTS.cookies.path} underline="hover">
          Préférences cookies
        </MuiLink>
      </Stack>
    </Stack>
  );
}